import React from "react";
import { Dialog } from "@fluentui/react-northstar";
import Constants from "../../../constants/text-constants";
import PropTypes from "prop-types";

const ErrorDialog = (props) => {
  const { onConfirm, title, text, testId } = props;

  return (
    <Dialog
      data-testid={testId}
      confirmButton={Constants.CLOSE}
      content={text}
      header={title}
      open={true}
      onConfirm={onConfirm}
      onCancel={onConfirm}
    />
  );
};

ErrorDialog.propTypes = {
    onConfirm: PropTypes.func,
    title: PropTypes.string,
    text: PropTypes.string,
    testId: PropTypes.string,
};

ErrorDialog.defaultProps = {
    title: "Error",
    text: "",
    testId: "errorDialog",
};

export default ErrorDialog;
